import { getExecutingEnvironment } from "@app/resolveModule/env";
import DefaultError from "@ext/errorHandlers/logic/DefaultError";
import ErrorType from "@ext/errorHandlers/model/ErrorTypes";
import t from "@ext/localization/locale/translate";
import type { ParsePosition } from "@ext/markdown/core/Parser/Error/ParsePosition";

class ParseError extends DefaultError {
	constructor(cause: Error, content: string, position?: ParsePosition) {
		const isWeb = getExecutingEnvironment() === "web" || getExecutingEnvironment() === "tauri";
		const key = isWeb ? "article.error.parse.web" : "article.error.parse.default";
		super(t(key), cause, isWeb ? { html: true } : undefined);
		this.name = "ParseError";
		// `reason` is what the parser said, in its own words — the same prop the frontmatter error
		// carries, so the page renders both the same way, under the same fold.
		this.setProps({ content, position, reason: cause?.message });
	}

	get type() {
		return ErrorType.Parse;
	}
}

export default ParseError;
